<template>
  <div>
    <div :class="classes">
      <div :style="barStyle" :class="barClasses"></div>
      <div v-if="marker" :style="markerStyle" class="po-progress-bar__marker"></div>
    </div>
    <div v-if="label" class="po-progress-bar__label">{{ label }}</div>
  </div>
</template>
<script>

const errorThreshold = 30
const warningThreshold = 70
const baseClass = 'po-progress-bar'
const valueClass = `${baseClass}__value`

export default {
  name: 'PoProgressBar',
  props: {
    label: String,
    value: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    marker: Number,
    modDisabled: Boolean
  },
  computed: {
    percentage () {
      return this.value / this.max * 100
    },
    classes () {
      return [baseClass, {
        [`${baseClass}--disabled`]: this.modDisabled
      }]
    },
    barStyle () {
      const width = Math.max(Math.min(100, this.percentage), 0)
      return { width: `${width}%` }
    },
    markerStyle () {
      const left = Math.min(100, this.marker)
      return { left: `${left}%` }
    },
    barClasses () {
      return [valueClass, {
        [`${valueClass}--warning`]: this.percentage > errorThreshold && this.percentage <= warningThreshold,
        [`${valueClass}--error`]: this.percentage <= errorThreshold
      }]
    }
  }
}
</script>
<style lang="scss">

  $po-progress-bar-height: 0.5em;
  $po-progress-bar-base-bg: rgba(128, 128, 128, .4);
  $po-progress-bar-marker-bg: rgba(128, 128, 128, .8);

  .po-progress-bar {
    position: relative;
    border-radius: $po-progress-bar-height / 2;
    height: $po-progress-bar-height;
    background-color: $po-progress-bar-base-bg;

    &--disabled {
      opacity: .25;
    }

    &__value {
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      bottom: 0;

      border-radius: $po-progress-bar-height / 2;
      background-color: #1fc275;

      transition: all 1s ease;

      &--warning {
        background-color: #f5a623;
      }

      &--error {
        background-color: #ff2018;
      }
    }

    &__marker {
      position: absolute;
      top: - $po-progress-bar-height / 2;
      bottom: - $po-progress-bar-height / 2;
      width: 1px;
      background-color: $po-progress-bar-marker-bg;
    }

    &__label {
      position: relative;
      text-align: right;
      margin-top: $po-progress-bar-height / 3;
    }
  }
</style>
